import { useContext, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { LayoutContext, TutorialDialog } from '@/_shared/components';
import { TutorialKeys } from '@/_shared/constants';
import { useTutorialCheck } from '@/_shared/hooks';
import { useDialog } from '@/_shared/hooks/useDialog';
import { DialogPendingImportEmployees, DialogImportEmployeesStillRunning } from '../components';
import { PeopleIntro } from '../components/PeopleIntro/PeopleIntro';

export const PeopleScreen = () => {
  const t = useTranslations('people.tutorial.slides');

  const { openDialog: openDialogPeopleTutorial } = useDialog('peopleTutorial');
  const { setLayout } = useContext(LayoutContext);
  const { hasAlreadySeenTutorial } = useTutorialCheck();

  const slides = [
    {
      title: t('slide1.title'),
      description: t('slide1.description'),
      assetName: 'tutorialPeopleSlide1',
    },
    {
      title: t('slide2.title'),
      description: t('slide2.description'),
      assetName: 'tutorialPeopleSlide2',
    },
    {
      title: t('slide3.title'),
      description: t('slide3.description'),
      assetName: 'tutorialPeopleSlide3',
    },
    {
      title: t('slide4.title'),
      description: t('slide4.description'),
      assetName: 'tutorialPeopleSlide4',
    },
  ];

  useEffect(() => {
    if (!hasAlreadySeenTutorial(TutorialKeys.People)) {
      openDialogPeopleTutorial();
    }
  }, [hasAlreadySeenTutorial, openDialogPeopleTutorial]);

  useEffect(() => {
    setLayout({ title: 'people' });
  }, [setLayout, t]);

  return (
    <>
      <PeopleIntro />
      <TutorialDialog
        translationsKey='people.tutorial'
        dialogKey='peopleTutorial'
        slides={slides}
      />
      <DialogPendingImportEmployees />
      <DialogImportEmployeesStillRunning />
    </>
  );
};
